import { c as _c } from "react/compiler-runtime";
import { Trans } from 'react-i18next';
import PreviousWatchlistCheckEvents from './components/previous-watchlist-check-events';
const WatchlistCheckEventHeader = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><p className="text-body-2 text-tertiary" data-testid="watchlist-check-event-header"><Trans ns="entity-details" i18nKey={_temp} components={{
          b: <b className="text-label-2 text-primary" />
        }} /></p><PreviousWatchlistCheckEvents /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default WatchlistCheckEventHeader;
function _temp($) {
  return $.auditTrail.timeline.watchlistCheckEvent.title;
}